import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { from } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'
import { PaymentReferencesService } from 'src/pages/admin/settings/admin-setting-payments/payment-references/payment-references.service'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { loadPaymentReferences, loadPaymentReferencesFailure, loadPaymentReferencesSuccess } from './payment-reference.actions'

@Injectable()
export class PaymentReferenceEffects {
  private actions$ = inject(Actions)
  private PaymentReferences = inject(PaymentReferencesService)
  private toaster = inject(ToasterService)


  loadPaymentReferences$ = createEffect(() => this.actions$.pipe(
    ofType(loadPaymentReferences),
    switchMap(action =>
      from(this.PaymentReferences.getPaymentReferences()).pipe(
        map(paymentReferences => loadPaymentReferencesSuccess({
          tableKey: action.tableKey,
          paymentReferences: paymentReferences,
        })),
        catchAndLog(this.toaster, 'Unable to fetch paymentReferences', loadPaymentReferencesFailure
      )))))
}
